import request from '@/http/request'
import wayCode from "@/utils/wayCode";
import channelUserIdUtil from "@/utils/channelUserId";
import config from '@/config'

/** 获取url **/
export function getChannelUserId (redirectData) {
  return request.request({
    url: '/ipay/qr/channelUserId',
    method: 'POST',
    data: Object.assign({}, { wayCode: wayCode.getPayWay().wayCode, token: config.cacheToken,code: config.openid}, redirectData)
  })
}

/** 调起支付接口, 获取支付数据包 **/
export function getPayPackage (amount, remark) {
  const payWay = wayCode.getPayWay()
  return request.request({
    url: '/ipay/qr/pay',
    method: 'POST',
    data: {
      wayCode: payWay.wayCode,
      token: config.cacheToken,
      amount: amount,
      buyerRemark: remark,
      channelUserId: payWay.wayCode === 'WX_JSAPI' ? channelUserIdUtil.getChannelUserId() : ''
    }
  })
}

/** 调起支付接口, 获取订单信息 **/
export function getPayOrderInfo () {
  return request.request({
    url: '/ipay/qr/payOrderInfo',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}
